import IntersectionObserver from '@researchgate/react-intersection-observer';
import { useRef, useState } from 'react';
import { Button, useIsMounted } from '@simplywallst/ui-core';
import { cn } from '@simplywallst/ui-core/next';
import { Transition } from 'react-transition-group';

type Props = {
  onModalOpen: () => void;
};

// TODO TW - Remove the important from classes once we have tv for a button component
const floatingButtonBaseClasses = cn([
  '!fixed',
  'bottom-[calc(72px+env(safe-area-inset-bottom))]',
  'right-x3',
  '!rounded-[20px]',
  'z-10',
  '!duration-500',
  '!transition-[opacity,transform]',
  'opacity-0',
  'translate-y-0',
]);

export const ViewValuationButton = ({ onModalOpen }: Props) => {
  const buttonRef = useRef(null);
  const [isButtonInView, setIsButtonInView] = useState(false);
  const isMounted = useIsMounted();

  return (
    <>
      <IntersectionObserver
        onChange={(entry) => setIsButtonInView(entry.isIntersecting)}
      >
        <Button styleType="loudLarge" onClick={onModalOpen}>
          View Valuation
        </Button>
      </IntersectionObserver>
      <Transition
        in={!isButtonInView && isMounted}
        timeout={500}
        mountOnEnter={false}
        unmountOnExit
        nodeRef={buttonRef}
      >
        {(state) => (
          <Button
            className={cn(
              floatingButtonBaseClasses,
              (state === 'entered' || state === 'entering') &&
                '-translate-y-x4 opacity-100'
            )}
            styleType="louderLarge"
            onClick={onModalOpen}
            ref={buttonRef}
          >
            View valuation
          </Button>
        )}
      </Transition>
    </>
  );
};
